import type { DalError, DalReturn } from "@/core/dal/data.type";
import { dalDbOperation } from "@/core/dal/helper";
import type { TripFormPayload } from "@/core/schemas/flight.form.schema";
import type ApiService from "@/core/services/api.service";
import type APIEndpointsService from "@/core/services/api-endpoints.service";

class TripsService {
  constructor(
    private apiService: ApiService,
    private apiEndpointsService: APIEndpointsService
  ) {}

  submitRequest(data: TripFormPayload): Promise<DalReturn<void, DalError>> {
    return dalDbOperation(async () => {
      await this.apiService.post(
        this.apiEndpointsService.getRoutes().tripReq.post(),
        data
      );
    });
  }
}

export default TripsService;
